import { Button, Dialog, Text } from '~/shared/ui'

export function DeleteClaimDialog({
  onClose,
  onConfirm,
  isPending,
}: {
  onClose: () => void
  onConfirm: () => void
  isPending: boolean
}) {
  return (
    <Dialog
      size="sm"
      onClose={onClose}
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            raised
            onClick={onConfirm}
            disabled={isPending}
          >
            Delete
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-2">
        <Text
          className="text-text-primary"
          appearance="SUBTITLE2"
        >
          Delete patient claim
        </Text>
        <Text
          className="text-text-secondary"
          appearance="CAPTION"
        >
          You're about to remove this patient claim and its service lines from the document.
          <br />
          This action cannot be undone.
        </Text>
      </div>
    </Dialog>
  )
}
